import MDBox from "../../../../components/MDBox";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import { useCallback, useEffect, useState} from "react";
import {useApi} from "../../../../services/helpers";
import MDTypography from "../../../../components/MDTypography";
import {DoneText, NewPMButton} from "../styles";
import {Icon} from "@mui/material";
import CustomerCell from "../../../../layouts/ecommerce/orders/order-list/components/CustomerCell";
import MDButton from "../../../../components/MDButton";
import MDInput from "../../../../components/MDInput";
import debounce from "lodash.debounce";
import AddBaseModal from "../../../../components/add-base-modal/AddBaseModal";
import {ROLES} from "../../../../services/constants";
import ConfirmDialogModal from "../../../../components/ConfirmDialogModal";
import {observer} from "mobx-react";


export const AddPackageModal = observer(({open, item, onClose, loading}) => {
  const api = useApi()
  const [packages, setPackages] = useState([])
  const [selectedPackages, setSelectedPackages] = useState(item?.packages?.map((item) => item.id) || [])
  const [searchValue, setSearchValue] = useState(null)

  useEffect(() => {
    getPackages({search: ""})
  }, [])

  const getPackages = ({search}) => {
    api.getAllPackages({
      search: search,
      page: 1,
      page_size: 10,
    }).handle({
        onSuccess: (result) => { setPackages(result.data.results) },
        errorMessage: 'Error getting managers',
    })
  }

  const searchProduct = (value) => {
    getPackages({search: value})
  }

  const debouncedInputChange = useCallback(
    debounce(searchProduct, 300)
    , [])

  const addPackages = () => {
    api.updatePackagesForGroup(item.id, {packages: selectedPackages}).handle({
      successMessage: 'Packages updated successfully',
      errorMessage: 'Error updating Packages',
      onFinally: () => { onClose() },
    })
  }

  const handleSelectedPackages = (id) => {
    setSelectedPackages(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  }

  return (
    <AddBaseModal
      open={open}
      loading={loading}
      handleClose={() => {
        onClose()
      }}
      title={'Update Packages'}
      headerContent={
        <MDTypography
          variant='h6'
          sx={DoneText}
          onClick={() => {
            addPackages()
            onClose()
          }}
        >
          Done
        </MDTypography>
      }
      showActions={false}
      modalContainer={{height: pxToRem(820)}}
    >
      <MDBox padding={`${pxToRem(20)} ${pxToRem(24)}`} overflow={'auto'}>
        <MDInput
          sx={{width: '100%'}}
          placeholder={'Search for packages'}
          value={searchValue}
          onChange={(e) => {
            debouncedInputChange(e.target.value)
            setSearchValue(e.target.value);
          }}
          InputProps={{
            endAdornment:
              <Icon fontSize='medium' sx={({palette: {icons}}) => ({color: icons.search_icon})}>
                search
              </Icon>
          }}
        />
        <MDBox display='flex' flexDirection='column' gap={pxToRem(28)}>
          {!packages.length
            ? <MDBox height={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <MDTypography variant='subtitle2'>No packages found</MDTypography>
              </MDBox>
            : packages.map(brandPackage => (
            <MDBox key={brandPackage.id} border='none' display='flex' justifyContent='space-between' alignItems='center'>
              <CustomerCell
                name={brandPackage.name}
                image={brandPackage.logo}
                color={"dark"}
                styles={{fontSize: '1rem'}}
              />
              <MDButton
                variant={"outlined"}
                color={selectedPackages.includes(brandPackage.id) ? "error" : "secondary"}
                onClick={() => {
                  handleSelectedPackages(brandPackage?.id)
                }}
                sx={NewPMButton}
              >
                {selectedPackages.includes(brandPackage.id)  ? 'Remove' : 'Add'}
              </MDButton>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
    </AddBaseModal>
  )
})
